<template>
  <hi-page-column grow></hi-page-column>
</template>

<script>
import HiPageColumn from "@/components/scaffold/HiPageColumn";
export default {
  name: "Leads_Root",
  components: {
    HiPageColumn
  }
};
</script>

<style scoped></style>
